



































import {Component, Vue, Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";

import IFlagRu from '@/components/icons/IFlagRu.vue'
import IFlagEn from '@/components/icons/IFlagEn.vue'
import IFlagDe from '@/components/icons/IFlagDe.vue'

const locale = namespace('locale')


@Component({
  components:{
    'i-flag-ru':IFlagRu,
    'i-flag-en':IFlagEn,
    'i-flag-de':IFlagDe,
  }
})
export default class SelectLocaleNew extends Vue {

  @locale.Getter('getLocale') protected getLocale:any
  @locale.Mutation('updateLocale') protected updateLocale:any

  protected showLanguages: boolean = false

  protected languages: any = [
    {id:'ru', text:'Русский', icon:'i-flag-ru'},
    {id:'en', text:'English', icon:'i-flag-en'},
    {id:'de', text:'Deutsch', icon:'i-flag-de'},
  ]

  public get lang(): any {
    return this.getLocale
  }
  public set lang(lang: any) {
    if(lang) this.updateLocale(lang)
  }

  get currentLang(): any {
    return this.languages.find((lang:any) => lang.id == this.lang)
  }
}



